function authHeader() {
  const sub = localStorage.getItem('sub');
  const accessToken = localStorage.getItem('accessToken');

  if (sub && accessToken) {
    return { 
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0',
      Authorization: `Bearer ${accessToken}`
    }; // for Spring Boot back-end
    // return { 'x-access-token': accessToken }; // for Node Express back-end
  }
    return {};
}

export default authHeader